const CREATE_TENANT = 'CREATE_TENANTS';
const CREATE_TENANT_SUCCESS = 'CREATE_TENANTS_SUCCESS';
const CREATE_TENANT_ERROR = 'CREATE_TENANTS_ERROR';
const UPDATE_TENANT = 'UPDATE_TENANTS';
const UPDATE_TENANT_SUCCESS = 'UPDATE_TENANTS_SUCCESS';
const UPDATE_TENANT_ERROR = 'UPDATE_TENANTS_ERROR';
const FETCH_TENANT = 'FETCH_TENANTS';
const FETCH_TENANT_SUCCESS = 'FETCH_TENANTS_SUCCESS';
const FETCH_TENANT_ERROR = 'FETCH_TENANTS_ERROR';
const TENANT_DETAILS_IS_EDIT = 'TENANTS_DETAILS_IS_EDIT';
const ADD_USER_IN_MANAGER = 'ADD_USER_IN_MANAGER';
const FETCH_TENANTS_UTIL_DATA = 'FETCH_TENANTS_UTIL_DATA';
const FETCH_TENANTS_UTIL_DATA_SUCCESS = 'FETCH_TENANTS_UTIL_DATA_SUCCESS';
const FETCH_ALL_TENANTS = 'FETCH_ALL_TENANTS';
const FETCH_ALL_TENANTS_SUCCESS = 'FETCH_ALL_TENANTS_SUCCESS';
const FETCH_ALL_TENANTS_ERROR = ' FETCH_ALL_TENANTS_ERROR';
const DELETE_TENANT = 'DELETE_TENANT';
const DELETE_TENANT_SUCCESS = 'DELETE_TENANTS_SUCCESS';
const DELETE_TENANT_ERROR = 'DELETE_TENANTS_ERROR';
const DELETE_TENANT_ATTACH = 'DELETE_TENANTS_ATTACH';
const DELETE_TENANT_ATTACH_SUCCESS = 'DELETE_TENANTS_ATTACH_SUCCESS';
const DELETE_TENANT_ATTACH_ERROR = 'DELETE_TENANTS_ATTACH_ERROR';
const TENANT_DETAIL_CLEANUP_FUNC = 'TENANTS_DETAIL_CLEANUP_FUNC';
const TENANT_NOTIF_IS_EDIT = 'TENANTS_NOTIF_IS_EDIT';
const UPDATE_TENANT_NOTIFICATION = 'UPDATE_TENANTS_NOTIFICATION';
const UPDATE_TENANT_NOTIFICATION_SUCCESS =
  'UPDATE_TENANTS_NOTIFICATION_SUCCESS';
const UPDATE_TENANT_NOTIFICATION_ERROR = 'UPDATE_TENANTS_NOTIFICATION_ERROR';
const SET_TENANTS_MANAGER_STATE = 'SET_TENANTS_MANAGER_STATE';

export {
  CREATE_TENANT,
  CREATE_TENANT_SUCCESS,
  CREATE_TENANT_ERROR,
  UPDATE_TENANT,
  UPDATE_TENANT_SUCCESS,
  UPDATE_TENANT_ERROR,
  FETCH_TENANT,
  FETCH_TENANT_SUCCESS,
  FETCH_TENANT_ERROR,
  ADD_USER_IN_MANAGER,
  TENANT_DETAILS_IS_EDIT,
  FETCH_TENANTS_UTIL_DATA,
  FETCH_TENANTS_UTIL_DATA_SUCCESS,
  FETCH_ALL_TENANTS,
  FETCH_ALL_TENANTS_SUCCESS,
  FETCH_ALL_TENANTS_ERROR,
  DELETE_TENANT,
  DELETE_TENANT_SUCCESS,
  DELETE_TENANT_ERROR,
  DELETE_TENANT_ATTACH,
  DELETE_TENANT_ATTACH_SUCCESS,
  DELETE_TENANT_ATTACH_ERROR,
  TENANT_DETAIL_CLEANUP_FUNC,
  TENANT_NOTIF_IS_EDIT,
  UPDATE_TENANT_NOTIFICATION,
  UPDATE_TENANT_NOTIFICATION_SUCCESS,
  UPDATE_TENANT_NOTIFICATION_ERROR,
  SET_TENANTS_MANAGER_STATE,
};
